<script setup>
import { ShieldCheckIcon, ClockIcon, StarIcon, UserGroupIcon } from '@heroicons/vue/24/outline'

const stats = [
    {
        value: '30+',
        label: 'Let zkušeností',
        description: 'v oboru instalatérství',
        icon: ClockIcon,
    },
    {
        value: '500+',
        label: 'Spokojených zákazníků',
        description: 'v celé České republice',
        icon: UserGroupIcon,
    },
    {
        value: '100%',
        label: 'Záruka na práci',
        description: 'kvalita na prvním místě',
        icon: ShieldCheckIcon,
    },
    {
        value: '24h',
        label: 'Havarijní služba',
        description: 'jsme tu pro vás',
        icon: StarIcon,
    },
]
</script>

<template>
    <section class="relative isolate overflow-hidden bg-gray-900 px-2 py-24 sm:py-32 lg:px-0">
        <div class="section-width relative">
            <div class="mx-auto max-w-2xl text-center">
                <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">Proč si vybrat právě nás?</h2>
                <p class="mt-4 text-lg text-gray-300">
                    Jsme rodinná firma s dlouholetou tradicí. Naším cílem je spokojenost každého zákazníka.
                </p>
            </div>

            <div class="mx-auto mt-16 grid max-w-5xl grid-cols-2 gap-2 lg:grid-cols-4 lg:gap-8">
                <div
                    v-for="stat in stats"
                    :key="stat.label"
                    class="group relative rounded-2xl border border-white/30 bg-white/10 p-6 text-center ring-1 backdrop-blur-sm transition hover:bg-white/20"
                >
                    <div class="bg-brand-primary/20 mx-auto mb-4 flex size-12 items-center justify-center rounded-xl">
                        <component
                            :is="stat.icon"
                            class="text-brand-primary size-6"
                        />
                    </div>
                    <div class="text-brand-primary text-3xl font-bold sm:text-4xl">{{ stat.value }}</div>
                    <div class="mt-2 text-sm font-semibold text-white">{{ stat.label }}</div>
                    <div class="mt-1 text-xs text-gray-400">{{ stat.description }}</div>
                </div>
            </div>
        </div>

        <svg
            viewBox="0 0 1024 1024"
            class="absolute top-1/2 left-1/2 -z-10 size-256 -translate-x-1/2 mask-[radial-gradient(closest-side,white,transparent)] opacity-30"
            aria-hidden="true"
        >
            <circle
                cx="512"
                cy="512"
                r="512"
                fill="url(#stats-gradient)"
                fill-opacity="0.7"
            />
            <defs>
                <radialGradient id="stats-gradient">
                    <stop stop-color="#0ea5e9" />
                    <stop
                        offset="1"
                        stop-color="#0284c7"
                    />
                </radialGradient>
            </defs>
        </svg>
    </section>
</template>
